import React from 'react';

const SkeletonLoader = ({ type = 'table', count = 5 }) => {
  if (type === 'table') {
    return (
      <div className="animate-pulse">
        {[...Array(count)].map((_, index) => (
          <div key={index} className="h-10 bg-gray-700 rounded mb-2"></div>
        ))}
      </div>
    );
  }

  if (type === 'form') {
    return (
      <div className="animate-pulse">
        <div className="h-8 bg-gray-700 rounded w-3/4 mb-4"></div>
        <div className="h-8 bg-gray-700 rounded mb-4"></div>
        <div className="h-32 bg-gray-700 rounded mb-4"></div>
        <div className="h-8 bg-gray-700 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-700 rounded mb-4"></div>
       </div>
    );
  }

  return (
    <div className="animate-pulse">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="h-4 bg-gray-700 rounded w-full mb-2"></div>
      ))}
    </div>
  );
};

export default SkeletonLoader;